import { useState } from 'react'
import Popup from 'src/Components/Popup'
import Input from 'src/Components/Form/Input'
import style from './style.module.scss'
import DatePicker from 'src/Components/Form/DatePicker'
import { KeyValueInput } from 'src/Components/Form/KeyValueInput'
import { IClientsGoal } from 'src/utils/Interfaces/client.interface'


interface Contract {
  name: string
  startDate: string
  endDate: string
  goals: IClientsGoal[]
}

interface Props {
  onNewContract: (data: Contract) => void
  setNewContractPopup: (value: boolean) => void
}

const GOALS = ['ARPU', 'CR', 'LTV']

export const ContractPopup = ({ onNewContract, setNewContractPopup }: Props) => {
  const [name, setName] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [goals, setGoals] = useState<IClientsGoal[]>([]);

  const handleNewContract = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onNewContract({
      name,
      startDate: startDate,
      endDate: endDate,
      goals,
    });
  }
  return (
    <Popup className={style.new_contract} title="Add new contract" closePopup={() => setNewContractPopup(false)}>
      <form onSubmit={handleNewContract}>
        <Input value={name} name="name" label="Name" onChange={(e) => setName(e.target.value)} required />
        <DatePicker value={startDate} name="start_date" label="Start date" onChange={(e) => setStartDate(e.target.value)} required />
        <DatePicker value={endDate} name="end_date" label="End date" onChange={(e) => setEndDate(e.target.value)} required />
        <KeyValueInput keyList={GOALS} label="Goals" onChange={(values) => setGoals(values)} />
        
        <button className="btn" type="submit">
          Add
        </button>
      </form>
    </Popup>
  )
}
